import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TinymcehtmleditorComponent } from '../tinymcehtmleditor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { RouterModule } from '@angular/router';
import { LanguageModule } from '../../language/language.module';



@NgModule({
  declarations: [TinymcehtmleditorComponent],
  exports:[TinymcehtmleditorComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    RouterModule,
    LanguageModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TinymcehtmleditorModule { }
